import {colorSchemeValues} from "@webng/liveblog";
import {supportedLocales} from "@webng-types/i18n";
import z from "zod";
import {createPartialParser, removeNullValues} from "./utils";
import {ParsePayload} from "zod/v4/core";

export const colorRegex = /^$|^#[0-9A-F]{3}([0-9A-F]{3})?$/

export const useCookiesValues = ["none", "functional", "all"] as const
export type UseCookiesType = typeof useCookiesValues[number]

export function preprocessSharedThemeConfiguration(arg: unknown, ctx: ParsePayload): unknown {
  const step1 = removeNullValues(arg, ctx)
  return step1
}

export const rawSharedThemeConfigurationSchema = z.object({
  locale: z.enum([...supportedLocales, ""]).default(""),
  colorScheme: z.enum(colorSchemeValues).default("light"),
  useCookies: z.enum(useCookiesValues).default("all")
})

export type SharedThemeConfiguration = z.infer<typeof rawSharedThemeConfigurationSchema>

export const sharedThemeConfigurationSchema = z.preprocess(preprocessSharedThemeConfiguration, rawSharedThemeConfigurationSchema)

export const parsePartialSharedThemeConfiguration = createPartialParser<SharedThemeConfiguration>(rawSharedThemeConfigurationSchema, preprocessSharedThemeConfiguration)
